import { useContext, useState } from "react"
import { MdContentCopy, MdDelete } from "react-icons/md"
import { checkOrganizerInvite, deleteInviteDoc, getOrganizerPendingInvites, newOrganizerInvite } from "../../Requests/firebaseFirestore"
import { sendOrganizerInvite } from "../../Requests/sendMail"
import Modal from "../Modal"
import UserContext from "../../Context/UserContext"

export default function StaffAsOrganizer(){
  const defaultOrganizer={
    name:'',
    email:''
  }
  const [newOrganizer, setNewOrganizer] = useState(defaultOrganizer)
  const [alert, setAlert] = useState('')
  const [sending, setSending] = useState(false)
  const [invitesModal, setInvitesModal] = useState(false)
  const [invites, setInvites] = useState([])
  const [message, setMessage] = useState('')

  const handleInvitesModal = async () => {
    if(!invitesModal){
      const invts = await getOrganizerPendingInvites()
      setInvites([...invts])
    }
    setInvitesModal(!invitesModal)
  }

  const {user, seeAs, url} = useContext(UserContext)

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text)
  }
  
  const handleInputChange = (e) => {
    const {name, value} = e.target
    setMessage('')
    setAlert('')
    setNewOrganizer({...newOrganizer,[name]: value})
  }
  
  const handleSubmit = async (e) =>{
    e.preventDefault()
    setSending(true)
    const check = await checkOrganizerInvite(newOrganizer.email)
    if(check){
      setAlert('Ya se ha enviado una invitación')
    }else{
      setAlert('')
      const inviteId = await newOrganizerInvite(newOrganizer)
      const send = await sendOrganizerInvite({inviteId:inviteId, email:newOrganizer.email})
      if(send.status==='success'){
        setMessage('Invitación enviada')
        setNewOrganizer({})
      }else{
        await deleteInviteDoc(inviteId)
        setAlert('No se ha podido enviar la invitación')
       }
    }
    setSending(false)
  }

  const handleDeleteInvite = async (inviteId) => {
    await deleteInviteDoc(inviteId)
    handleInvitesModal()
  }

  return(<>
    <div className="w-1/2 max-w-[500px] min-w-[300px] mx-auto">
      <div className="flex sm:justify-start justify-center mt-4">
        <button className="action-btn mx-auto" onClick={handleInvitesModal}>Invitaciones pendientes</button>
      </div>
      <div className="border border-stone-400 mt-5 mx-auto rounded-[10px] py-4 px-6 flex flex-col justify-center gap-4">
        <h1 className="text-xl text-center">Nuevo organizador</h1>
        <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
          <div className="input-holder w-[75%]">
            <input type="text" id="new-organizer-name" name='name' onChange={handleInputChange} value={newOrganizer.name||''} required/>
            <label htmlFor="new-organizer-name">Nombre</label>
          </div>
          <div className="input-holder w-[75%]">
            <input type="email" id="new-organizer-email" name="email" onChange={handleInputChange} value={newOrganizer.email||''} required />
            <label htmlFor="new-organizer-email">Email</label>
          </div>
          {alert===''?<></>:
           <span className="text-red-500 text-center">{alert}</span>
          }
          {message === '' ?<></>:
            <span className="block mx-auto text-center">{message}</span>
          }
          <button className=" send-btn " disabled={sending}>{sending?'Enviando...':'Invitar'}</button>
        </form>
      </div>
    </div>
    <Modal isActive={invitesModal} handle={handleInvitesModal} title='Invitaciones pendientes' size={'lg'}>
    <div className="w-[90%] mx-auto">
        {
          invites.length===0?
          <h1 className="font-semibold text-xl text-center my-[50px]">No se encontraron invitaciones.</h1>:<>
          <div className="table-holder">
            <table className="w-full min-w-[500px]">
              <thead>
                <tr className="bg-[#F03623] text-white font-semibold">
                  <th>Acción</th>
                  <th>Enviado a</th>
                  <th>Nombre</th>
                </tr>
              </thead>
              <tbody>
                {invites.map((invite, index)=>{return(
                  <tr key={index}>
                    <td><div className="flex gap-1">
                      <button className="action-button border-red-500 text-red-500 hover:text-white hover:bg-red-500 active:bg-red-700 duration-150" onClick={()=>{handleDeleteInvite(invite.id)}}><MdDelete size={25}/></button>
                    <button className="action-button border-blue-500 text-blue-500 hover:text-white hover:bg-blue-500 active:bg-blue-700 duration-150" onClick={()=>{handleCopy(`${url}/newuser/organizer/${invite.id}`)}}><MdContentCopy size={25}/></button>
                    </div></td>
                    <td>{invite.email}</td>
                    <td>{invite.name}</td>
                  </tr>
                )})}
              </tbody>
            </table>
           </div>
          </>
        }
        </div>
    </Modal>
  </>)
}